import { jsx } from "react/jsx-runtime";
import { Component } from "./Component.js";
import { AccessorProvider } from "../accessorPropagation/AccessorProvider.js";
const Entity = Component(
  ({ children, accessor }) => {
    return (
      // HACK: the ?. is actually important, despite the typings.
      /* @__PURE__ */ jsx(AccessorProvider, { accessor, children }, accessor?.key)
    );
  },
  "Entity"
);
export {
  Entity
};
//# sourceMappingURL=Entity.js.map
